import { render, staticRenderFns } from "./TitleCard.vue?vue&type=template&id=2b9cb29e&scoped=true&"
import script from "./TitleCard.vue?vue&type=script&lang=js&"
export * from "./TitleCard.vue?vue&type=script&lang=js&"
import style0 from "./TitleCard.vue?vue&type=style&index=0&id=2b9cb29e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9cb29e",
  null
  
)

export default component.exports